module.exports = __WEBPACK_EXTERNAL_MODULE_165__;


//////////////////
// WEBPACK FOOTER
// external "gemini/pinning/PinView"
// module id = 165
// module chunks = 2